/**
 * KeyEmpty component.
 */
import Props from '@shared/types/props/pressable';
import Screen from '@shared/utils/screen';
import styled from 'styled-components';

/**
 * Styled key empty.
 */
const KeyEmpty = styled.div<Props>`
  float: left;
  height: ${39 * Screen.widthRatio}px;
  margin-bottom: ${10 * Screen.widthRatio}px;
  margin-right: ${22 * Screen.widthRatio}px;
  position: relative;
  text-align: center;
  width: ${26 * Screen.widthRatio}px;
`;

export default KeyEmpty;
